// extracted by mini-css-extract-plugin
export default {"modalOverlay":"PO-z","modalContent":"QO-z","header":"RO-z","close":"SO-z"};